import { fg } from '@atlassian/jira-feature-gating';

const FrontierFormulaFieldD2D3Relayprovider = {
	get(): boolean {
		return fg('frontier-formula-field-d2-d3');
	},
};

export default FrontierFormulaFieldD2D3Relayprovider;
